import { render, staticRenderFns } from "./dutyEdit.vue?vue&type=template&id=cca79142&scoped=true&"
import script from "./dutyEdit.vue?vue&type=script&lang=js&"
export * from "./dutyEdit.vue?vue&type=script&lang=js&"
import style0 from "./dutyEdit.vue?vue&type=style&index=0&id=cca79142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca79142",
  null
  
)

export default component.exports